import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowRotateLeftFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowRotateLeftFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M11.18 13.5h-3a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3Z" />
          <path d="M14.18 5H8.15l2.58-3.5H7l-3.68 5 3.68 5h3.73L8.15 8h6.03c1.93 0 3.5 1.57 3.5 3.5v7h3v-7c0-3.58-2.92-6.5-6.5-6.5Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowRotateLeftFilled;